export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-500-d481339069fc9b88a1a029401b6c97e2.eot";